import { render, staticRenderFns } from "./site-setup-location-details-form.component.vue?vue&type=template&id=de2c23ce"
import script from "./site-setup-location-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./site-setup-location-details-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-setup-location-details-form.component.vue?vue&type=style&index=0&id=de2c23ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports